import React from 'react';
import Slider from 'react-slick';
import {defineMessages, FormattedMessage, FormattedDate} from 'react-intl';

const messages = defineMessages({
    readTitle: {
        id: 'news.read_title',
        defaultMessage: 'Читать'
    },
    companyNews: {
        id: 'news.company_news',
        defaultMessage: 'Новости компании'
    }
});

export default class News extends React.Component {
    static propTypes = {
        news: React.PropTypes.array.isRequired
    };

    constructor(props) {
        super(props);
        this._newsItemClick = this._newsItemClick.bind(this);
    }

    _newsItemClick(link, e) {
        e.preventDefault();

        window.open(link, 'News',
            "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
    }

    renderNews(news) {
        const newsElements = [];

        for (let i = 0; i < news.length; i++) {
            const newsItem = news[i];

            const link = newsItem.link;
            const newsItemClick = this._newsItemClick.bind(this, link);

            newsElements.push(<div  key={newsItem.id}>
                    <div className="slideshow--content__item">
                        <span className="slideshow--content__item__date">
                            <FormattedDate
                                value={newsItem.date}
                                day="numeric"
                                month="long"
                                year="numeric"/>
                        </span>
                        <span className="slideshow--content__item__content">
                            <strong className="slideshow--content__item__content__title">{newsItem.title}</strong>
                            <span>{newsItem.content}</span>
                        </span>
                        <a href={link}
                           onClick={newsItemClick}
                           className="slideshow--content__item__readmore"
                           target="_blank">
                            <FormattedMessage {...messages.readTitle} />
                        </a>
                    </div>
                </div>);
        }

        return newsElements;
    }

    ///TODO: fix 'same keys problem' or change to another slider
    render() {
        const news = this.props.news;

        if (!news || !news.length) {
            return false;
        }

        const settings = {
            dots: true,
            initialSlide: 0,
            infinite: true,
            speed: 1000,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 5000,
            className: "slideshow--content__list slideshow--content__list_js",
            cssEase: 'ease-in-out'
        };

        return (
            <div className="slideshow--content" style={{backgroundColor:'#9bbda8'}}>
                <h3 className="slideshow--content__title">
                    <FormattedMessage {...messages.companyNews} />
                </h3>
                <Slider {...settings}>
                    {this.renderNews(news)}
                </Slider>
            </div>
        );
    }

    /*render() {
        const news = this.props.news;

        if (!news || !news.length) {
            return false;
        }

        return (
            <div className="slideshow--content" style={{backgroundColor:'#9bbda8'}}>
                <h3 className="slideshow--content__title">
                    <FormattedMessage {...messages.companyNews} />
                </h3>
                {this.renderNews(news)}
            </div>
        );
    }*/
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/main-page/banners/news/News.jsx